import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.css']
})
export class UnauthorizedComponent {

  constructor(
    private router: Router,
    private location: Location
  ) { }

  retourAccueil(): void {
    this.router.navigate(['/dashboard']);
  }

  retourPrecedent(): void {
    this.location.back();
  }
}
